<template>
  <div>
    <Header title="调课申请"></Header>
    <div class="exchangeI">
      <van-tabs v-model="active" type="line" sticky animated>
        <van-tab title="调课申请" :disabled="isAble" v-if="!isAble">
          <div class="applyInfo">
            <p>{{ itemList.courseName }}</p>
            <ul>
              <li>
                当前周次：<span>{{ itemList.nowWeek }}</span>
              </li>
              <li>
                上课周次：<span>{{ itemList.week }}</span>
              </li>
              <li>
                时间：<span>{{ itemList.weekNote }}</span>
              </li>
              <li>
                地点：<span>{{ itemList.classRoom }}</span>
              </li>
              <li>
                班级：<span>{{ itemList.className }}</span>
              </li>
            </ul>
          </div>
          <div class="apply">
            <van-field
              v-model="tkfs.mc"
              label="调课方式"
              left-icon="eye-o"
              right-icon="arrow"
              input-align="right"
              placeholder="请点击选择"
              @click="onShow('调课方式', 'tkfs')"
              readonly
            />
            <van-field
              v-model="tklx"
              label="调课类型"
              left-icon="eye"
              right-icon="arrow"
              input-align="right"
              placeholder="请点击选择"
              @click="onShow('调课类型', 'tklx')"
              readonly
            />
            <!-- 调课类型转换 -->

            <span v-if="showType">
              <van-field
                v-model="jxbgzc"
                :label="tkType[3] ? '停课周次' : '教学变更周次'"
                left-icon="like"
                right-icon="arrow"
                input-align="right"
                placeholder="请点击选择"
                @click="
                  onShow(tkType[3] ? '停课周次' : '教学变更周次', 'jxbgzc')
                "
                v-if="
                  (tkType[1] || tkType[2] || tkType[3] || tkType[4]) &&
                    tklxdm != '9'
                "
                readonly
              />
              <van-field
                v-model="bgls.mc"
                :label="tkType[4] ? '对调老师' : '变更老师'"
                left-icon="fire"
                right-icon="arrow"
                input-align="right"
                placeholder="请点击选择"
                @click="onShow1"
                v-if="tkType[2] || tkType[4]"
                readonly
              />
              <van-field
                v-model="ddkb.kbTime"
                label="对调课表"
                left-icon="fire-o"
                right-icon="arrow"
                input-align="right"
                placeholder="请点击选择"
                @click="onShow('对调课表', 'ddkb')"
                v-if="tkType[4]"
                readonly
              />
              <van-field
                v-model="ddkb.ddzcName"
                label="对调周次"
                left-icon="fire-o"
                right-icon="arrow"
                input-align="right"
                placeholder="请点击选择"
                @click="onShow('对调周次', 'ddzc')"
                v-if="tkType[4]"
                readonly
              />
              <van-field
                v-model="xq.mc"
                label="星期几"
                left-icon="like-o"
                right-icon="arrow"
                input-align="right"
                placeholder="请点击选择"
                @click="onShow('星期几', 'xq')"
                v-if="!tkType[3] && !tkType[4]"
                readonly
              />
              <van-field
                v-model="qzjc.mc"
                label="起止节次"
                left-icon="location-o"
                right-icon="arrow"
                input-align="right"
                placeholder="请点击选择"
                @click="onShow('起止节次', 'qzjc')"
                v-if="!tkType[3] && !tkType[4]"
                readonly
              />

              <van-field
                v-model="dd.mc"
                label="地点"
                left-icon="location"
                right-icon="arrow"
                input-align="right"
                placeholder="请选择"
                @click="onShow('地点', 'dd')"
                v-if="(!tkType[3] && !tkType[4]) || tklxdm == '9'"
                readonly
              />
              <van-field
                v-model="shr.mc"
                label="审核人"
                left-icon="smile"
                right-icon="arrow"
                input-align="right"
                placeholder="请点击选择"
                @click="openShrWd()"
                readonly
              />

              <van-field
                v-if="schoolCode == '4152014577'"
                v-model="tklb.mc"
                label="调课类别"
                left-icon="eye-o"
                right-icon="arrow"
                input-align="right"
                placeholder="请点击选择"
                @click="onShow('调课类别', 'tklb')"
                readonly
              />

              <van-field
                v-if="schoolCode != '10054'"
                v-model="tkyy"
                rows="1"
                autosize
                left-icon="smile-o"
                label="调课原因"
                type="textarea"
                maxlength="200"
                placeholder="请点击填写"
              />

              <van-field
                v-if="schoolCode == '10054'"
                v-model="tkyy"
                label="调课原因"
                left-icon="eye-o"
                right-icon="arrow"
                input-align="right"
                placeholder="请点击选择"
                @click="onShow('调课原因', 'tkyy')"
                readonly
              />

              <van-field
                disabled
                v-if="schoolCode == '10054'"
                v-model="ttksm"
                rows="2"
                autosize
                left-icon="smile-o"
                label="调课须知"
                type="textarea"
              />

              <van-field
                v-model="checkStudentCt"
                left-icon="location"
                right-icon="arrow"
                input-align="right"
                label="检查学生冲突"
                placeholder="请点击选择"
                @click="onShow('检查学生冲突', 'checkXsCt')"
                readonly
              />
              <van-field
                label="上传附件"
                left-icon="setting"
                input-align="right"
                readonly
              >
                <template #input>
                  <van-uploader
                    :accept="fileUploadType" 
                    v-model="fileList"
                    :after-read="afterRead"
                    :max-size="10 * 1024 * 1024"
                    @oversize="onOversize"
                    :max-count="schoolCode==='13575'?5:1"
                  /> </template
              ></van-field>
              <div class="tksm_btnsm" v-if="schoolCode == '10054'">
                <span style="color: red;" >调代课教师需通知调代课课程学生</span>
                <br>
                <button @click="dowloadTksm">调课情况说明下载</button>
                
              </div>
              <van-field> </van-field>
            </span>
          </div>
        </van-tab>
        <van-tab title="申请记录">
          <div class="applyList">
            <van-dropdown-menu active-color="#7469F8">
              <van-dropdown-item
                ref="oid"
                v-model="optionDM"
                :options="option"
                @change="change"
              />
              <van-dropdown-item
                v-if="schoolCode == '10689'"
                ref="xqid"
                v-model="xnxqval"
                :options="xnxqOption"
                @change="change"
              />
            </van-dropdown-menu>
            <div class="list">
              <NOdata
                v-if="this.applyList.length == 0"
                title="未查询到调课记录"
              ></NOdata>
              <div
                v-else
                class="list-item"
                v-for="(item, index) of applyList"
                :key="index"
              >
                <div @click="goRecord(item)">
                  <p>{{ item.courseName }}</p>
                  <ul>
                    <li>调课方式：{{ item.changeMode }}</li>
                    <li>调课类型：{{ item.changeTypeName }}</li>
                  </ul>
                  <span :class="item.class">{{ item.auditStateName }}</span>
                </div>
                <div
                  class="csdiv"
                  v-if="item.iswfmes == '2' && schoolCode == '14666'"
                >
                  <button @click="doCancelSh(item)">撤销</button>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>

      <div class="bottom-btn" v-if="active == 0">
        <button @click="preSub">提交申请</button>
      </div>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.label"
        show-toolbar
        :columns="valueList.item"
        :default-index="valueList.value != 'jxbgzc' ? 0 : selectIndex"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.value);
          }
        "
        @cancel="show = false"
      />
    </van-popup>

    <van-popup v-model="show1" position="bottom">
      <div class="apply-pop">
        <div class="pop-title">
          <i class="close-icon" @click="show1 = false"></i>
          <p>审核人</p>
          <i class="confirm-icon" @click="resetCancel()"></i>
        </div>
        <div class="person">
          <button
            class="per-btn"
            ref="person"
            v-for="(item, index) in shrList"
            @click="personTap($event, index)"
            :key="item.id"
          >
            {{ item.name }}
          </button>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="show3"
      position="bottom"
      class="alter-pop"
      style="min-height:100%"
    >
      <alterTeacher @closePop="closeBgls" :isRadio="false"></alterTeacher>
    </van-popup>
    <van-popup
      v-model="showDdkb"
      position="bottom"
      class="alter-pop"
      style="min-height:100%"
    >
      <alterTeacherKbMsg
        @closePop_ddkb="closeDtKb"
        :isRadio="true"
        :ddParmMsg="ddParmMsg"
        :key="timer"
      ></alterTeacherKbMsg>
    </van-popup>
    <van-popup
      v-model="tkdd_show"
      round
      position="bottom"
      closeable
      style="min-height:70%"
    >
      <div class="popup_title">
        请选择地点<span>(搜索结果均为可用教室)</span>
      </div>
      <van-tabs v-model="tkddmc.active" type="line" @click="freshClassRoom()">
        <van-tab :title="tkddmc.xqmc">
          <van-radio-group v-model="tkddmc.selectXqid">
            <van-cell-group>
              <van-cell
                clickable
                v-for="(item, itemIndex) in tkddmc.xqList"
                :key="itemIndex"
              >
                {{ item.xqmc }}
                <template #right-icon>
                  <van-radio :name="item.xqid" @click="changeXq(item)" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </van-tab>
        <van-tab :title="tkddmc.jxlmc">
          <van-radio-group v-model="tkddmc.selectJxlid">
            <van-cell-group>
              <van-cell
                clickable
                v-for="(item, itemIndex) in tkddmc.jxlList"
                :key="itemIndex"
              >
                {{ item.jzwmc }}
                <template #right-icon>
                  <van-radio :name="item.jzwid" @click="changeJxl(item)" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </van-tab>
        <van-tab :title="tkddmc.jslxmc">
          <van-radio-group v-model="tkddmc.selectJslxid">
            <van-cell-group>
              <van-cell
                clickable
                v-for="(item, itemIndex) in tkddmc.jslxList"
                :key="itemIndex"
              >
                {{ item.jslxmc }}
                <template #right-icon>
                  <van-radio :name="item.jslxdm" @click="changeJslx(item)" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </van-tab>
        <van-tab :title="tkddmc.jsmc">
          <div v-if="ddList.mc.length <= 0" class="popup_title">
            未查询到可用教室
          </div>
          <van-radio-group v-else>
            <van-cell-group>
              <van-cell
                clickable
                v-for="(item, itemIndex) in ddList.mc"
                :key="itemIndex"
              >
                {{ item }}
                <template #right-icon>
                  <van-radio
                    :name="ddList.dm[itemIndex]"
                    @click="changeJsmc(ddList.dm[itemIndex], item)"
                  />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </van-tab>
      </van-tabs>
    </van-popup>
  </div>
</template>

<script>
import { Api } from "../../../../utils/axios";
import alterTeacher from "../../../common/alterTeacher";
import alterTeacherKbMsg from "../../../common/alterTeacherKbMsg";
import Vue from "vue";
import {
  Tab,
  Tabs,
  Cell,
  CellGroup,
  DropdownMenu,
  DropdownItem,
  Popup,
  Picker,
  Field
} from "vant";

Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Field);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Tab);
Vue.use(Tabs);
export default {
  data() {
    return {
      file: {},
      fileList: [],
      isAble: false,
      showType: false,
      tkType: [false, false, false, false, false],
      active: 0,
      itemList: {},
      show: false,
      show1: false,
      show3: false,
      show_tklb: true,
      tkfs: { mc: "", dm: "" },
      tklb: { mc: "", dm: "" },
      tklx: "",
      tklxdm: "",
      jxbgzc: "",
      bgzc: [],
      xq: {},
      qzjc: {},
      dd: {},
      shr: {},
      ddkb: {},
      reset: "",
      resetId: "",
      timer: "",
      tkyy: "",
      bgls: { mc: "", dm: "" },
      tklbList: { dm: [], mc: [] },
      tkfsList: { dm: [], mc: [] },
      checkCtCoum: { dm: ["1", "0"], mc: ["是", "否"] },
      tklxList: [],
      jxbgzcList: [
        {
          values: [],
          className: "column1",
          defaultIndex: 0
        },
        {
          values: [],
          className: "column2",
          defaultIndex: 1
        }
      ],
      xqList: [],
      qzjcList: { dm: [], mc: [] },
      ddList: { dm: [], mc: [] },
      shrList: [
        {
          id: "",
          name: "全部",
          isBtn: 0
        }
      ],
      shrListDefult: [
        {
          id: "",
          name: "全部",
          isBtn: 0
        }
      ],
      shrList_other: [
        {
          id: "",
          name: "全部",
          isBtn: 0
        }
      ],
      valueList: {
        label: "",
        value: "",
        item: []
      },
      columns: {
        tkfs: [],
        tklx: [],
        jxbgzc: [],
        xq: [],
        qzjc: [],
        dd: [],
        shr: [],
        ddkb: [],
        tklb: [],
        ddzc: []
      },
      optionDM: "",
      option: [
        { text: "全部", value: "" },
        { text: "审核中", value: "2" },
        { text: "未通过", value: "0" },
        { text: "已通过", value: "1" },
        { text: "待审核", value: "3" }
      ],
      xnxqval:'',
      xnxqOption:[],
      applyList: [],
      allList: [],
      schoolCode: "",
      tkdd_show: false,
      tkddmc: {
        xqmc: "校区",
        jxlmc: "教学楼",
        jslxmc: "教室类型",
        jsmc: "教室名称",
        active: 0,
        selectXqid: "",
        selectJxlid: "",
        selectJslxid: "",
        xqList: [],
        jxlList: [],
        jslxList: [],
        jsmcList: []
      },
      selectXq: "",
      xsShLcKz: "0",
      xsShXsSum: 0,
      otherCoder: "",
      nowCoderStuts: "0",
      ddParmMsg: [],
      showDdkb: false,
      selectIndex: 0,
      checkStudentCt: "是",
      checkStudentCtDm: "1",
      isTk: "",
      ttksm:'',
      tkfilename:'',
      fileUploadType:'.png,.jgp'
    };
  },
  watch: {
    active(val) {
      if (val == 1) {
        // 获取调课记录
        this.getApply();
      }
    },
    "tkfs.mc": {
      handler(val, oldVal) {
        if (val != oldVal && oldVal != "") {
          this.tklx = "";
          this.tkType = [false, false, false, false, false];
          this.showType = false;
        }
      },
      deep: true
    },
    tklx(val, oldVal) {
      if (val != oldVal) {
        this.jxbgzc = "";
        this.bgls = {};
        this.bgzc = [];
        this.xq = {};
        this.qzjc = {};
        this.dd = {};
        this.shr = {};
        this.ddkb = {};
      }
    }
  },
  methods: {
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      this.file = file.file;
    },
    onOversize(file) {
      this.$toast.fail("文件大小不能超过10M");
    },
    // 跳转到记录详情界面
    goRecord(item) {
      this.$router.push({
        path: "/noStop",
        query: {
          changeId: item.changeId
        }
      });
    },
    // 提交申请前判断是否有附件上传
    async preSub() {
      let formData = {};
      if (this.tklx == "") {
        this.$toast("请先选择调课类型");
        return false;
      }
      if (this.shr.dm == undefined || this.shr.dm == "") {
        this.shr.dm = "";
        for (let i = 0; i < this.shrList.length; i++) {
          if (this.shrList[i].id != "") {
            if (i == this.shrList.length - 1) {
              this.shr.dm += this.shrList[i].id;
            } else {
              this.shr.dm += this.shrList[i].id + ",";
            }
          }
        }
      }
      if (this.schoolCode == "4152014577" && this.tklb.dm == "") {
        this.$toast("请选择调课类别");
        return false;
      }

      if (this.tklx == "整体调课") {
        if (JSON.stringify(this.xq) == "{}") {
          this.$toast("请选择星期");
          return false;
        }
        if (JSON.stringify(this.qzjc) == "{}") {
          this.$toast("请选择起止节次");
          return false;
        }
        if (JSON.stringify(this.dd) == "{}") {
          this.$toast("请选择地点");
          return false;
        }
        if (this.tkyy == "" && this.schoolCode != '10054') {
          this.$toast("请填写调课原因");
          return false;
        }

        formData = {
          coursePlanId: this.itemList.coursePlanId,
          changeType: this.$route.query.isEx ? "6" : "0",
          classroomId: this.dd.dm,
          weekNote: this.qzjc.dm,
          week: "",
          teacherId: "",
          changeMode: this.tkfs.dm,
          applyReason: this.tkyy,
          oldWeek: this.itemList.week,
          userIds: this.shr.dm,
          changeCategory: this.tklb.dm,
          chekcXsCt: this.checkStudentCtDm
        };
      } else if (this.tklx == "部分调课") {
        if (JSON.stringify(this.xq) == "{}") {
          this.$toast("请选择星期");
          return false;
        }
        if (JSON.stringify(this.qzjc) == "{}") {
          this.$toast("请选择起止节次");
          return false;
        }
        if (JSON.stringify(this.dd) == "{}") {
          this.$toast("请选择地点");
          return false;
        }
        if (this.tkyy == "" && this.schoolCode != '10054') {
          this.$toast("请填写调课原因");
          return false;
        }
        formData = {
          coursePlanId: this.itemList.coursePlanId,
          changeType: "1",
          classroomId: this.dd.dm,
          weekNote: this.qzjc.dm,
          week: this.bgzc[1],
          teacherId: "",
          changeMode: this.tkfs.dm,
          applyReason: this.tkyy,
          oldWeek: this.bgzc[0],
          userIds: this.shr.dm,
          changeCategory: this.tklb.dm,
          chekcXsCt: this.checkStudentCtDm
        };
      } else if (this.tklx == "变更老师") {
        if (JSON.stringify(this.bgls) == "{}") {
          this.$toast("请选择变更老师");
          return false;
        }
        if (JSON.stringify(this.xq) == "{}") {
          this.$toast("请选择星期");
          return false;
        }
        if (JSON.stringify(this.qzjc) == "{}") {
          this.$toast("请选择起止节次");
          return false;
        }
        if (JSON.stringify(this.dd) == "{}") {
          this.$toast("请选择地点");
          return false;
        }
        if (this.tkyy == "" && this.schoolCode != '10054') {
          this.$toast("请填写调课原因");
          return false;
        }

        formData = {
          coursePlanId: this.itemList.coursePlanId,
          changeType: "5",
          classroomId: this.dd.dm,
          weekNote: this.qzjc.dm,
          week: this.bgzc[1],
          teacherId: this.bgls.dm,
          changeMode: this.tkfs.dm,
          applyReason: this.tkyy,
          oldWeek: this.bgzc[0],
          userIds: this.shr.dm,
          changeCategory: this.tklb.dm,
          chekcXsCt: this.checkStudentCtDm
        };
      } else if (this.tklx == "停课") {
        if (this.bgzc == "") {
          this.$toast("请选择停课周次");
          return false;
        }
        if (this.tkyy == "" && this.schoolCode != '10054') {
          this.$toast("请填写调课原因");
          return false;
        }
        formData.coursePlanId = this.itemList.coursePlanId; //课表id
        formData.changeType = "2"; //调课类型
        formData.weekNote = this.itemList.weekNote; //星期节次
        formData.week = this.bgzc; //周次
        formData.changeMode = this.tkfs.dm; //调课方式
        formData.oldWeek = this.itemList.week; //原周次
        formData.userIds = this.shr.dm; //审核人IDS
        formData.applyReason = this.tkyy; //调课原因
        formData.changeCategory = this.tklb.dm;
      } else if (this.tklx == "课程对调") {
        if (this.bgzc == "") {
          this.$toast("请填写教学变更周次");
          return false;
        }
        if (this.ddkb.kbId == "") {
          this.$toast("请选择对调课表");
          return false;
        }
        if (this.ddkb.ddzc == "") {
          this.$toast("请选择对调周次");
          return false;
        }
        if (this.tkyy == "" && this.schoolCode != '10054') {
          this.$toast("请填写调课原因");
          return false;
        }

        formData = {
          coursePlanId: this.itemList.coursePlanId,
          changeType: "6",
          // classroomId:this.classRoomId,
          // weekNote:this.nodeId,
          week: this.bgzc[0],
          ddzc: this.ddkb.ddzc,
          changeMode: this.tkfs.dm,
          applyReason: this.tkyy,
          oldWeek: this.itemList.week,
          userIds: this.shr.dm,
          ddCoursePlanId: this.ddkb.kbId,
          changeCategory: this.tklb.dm,
          chekcXsCt: this.checkStudentCtDm
        };
      } else if (this.tklxdm == "9") {
        if (JSON.stringify(this.dd) == "{}") {
          this.$toast("请选择地点");
          return false;
        }
        if (this.tkyy == "" && this.schoolCode != '10054') {
          this.$toast("请填写调课原因");
          return false;
        }
        formData = {
          coursePlanId: this.itemList.coursePlanId,
          changeType: "9",
          classroomId: this.dd.dm,
          weekNote: "",
          week: "",
          teacherId: "",
          changeMode: this.tkfs.dm,
          applyReason: this.tkyy,
          oldWeek: "",
          userIds: this.shr.dm,
          changeCategory: this.tklb.dm
        };
      }
      if (JSON.stringify(this.shr) == "{}") {
        this.$toast("请选择审核人");
        return;
      }
      if (this.nowCoderStuts == "1" && this.schoolCode == "12662") {
        formData.otherCode = this.otherCoder;
      }
      if (this.fileList.length > 0) {
        let ret = null;
        if (this.schoolCode === "13575") {
          let formData = new FormData();
          this.fileList.forEach(item => {
            formData.append("fileList", item.file);
          });

          ret = await Api.jsjysqUpload_13575(formData);
        } else {
           ret = await Api.jsjysqUpload({
            file: this.file,
            filename: this.file.name
          });
        }
        if (ret.code == 1) {
          this.sub(formData);
        } else {
          this.$toast.fail(msg);
          setTimeout(function() {
            this.$router.go(-2);
          }, 1500);
        }
      } else {
        this.sub(formData);
      }
    },
    // 提交申请
    async sub(formData) {
      formData.semesterId = this.itemList.semesterId;
      formData.noticeId = this.itemList.noticeId;
      const data = {
        formData: formData
      };
      let res = [];
      if (this.schoolCode == "11534") {
        if (this.itemList.sfsyk == "1") {
          formData.ywcode = "095";
          res = await Api.saveTransfer_syk(data);
        } else {
          if (this.tklxdm == "0") {
            formData.ywcode = this.itemList.ywcode_zt;
          } else {
            formData.ywcode = this.itemList.ywcode_dz;
          }
          res = await Api.saveTransferApplication(data);
        }
      } else {
        res = await Api.saveTransferApplication(data);
      }
      if (res.errorCode == "fail") {
        this.$toast(res.errorMessage);
        setTimeout(function() {
          this.$router.go(-2);
        }, 1500);
        return;
      } else if (res.errorCode == "success") {
        setTimeout(() => {
          this.$toast.success(res.errorMessage);
        }, 1500);
        this.active = 1;
        this.isAble = true;
      }
    },
    onShow1() {
      // 显示可选老师
      //if (this.tkType[4] && this.jxbgzc.trim() == "") {
      //this.$toast("请先点击选择教学变更周次");
      //return;
      //}
      this.timer = Math.random() * 100 * Math.random();
      this.show3 = true;
    },
    // 弹出弹框
    onShow(label, value) {
      if (this.schoolCode == "10054" && value + "" == "tkyy") {
        this.valueList.value = "" + value;
        this.valueList.label = label;
        this.valueList.item = ["因病", "因事", "因其他不可抗力因素"];
        this.show = true;
        return;
      }
      // 显示对调课程
      if (value + "" == "ddkb") {
        if (JSON.stringify(this.bgls) == "{}") {
          this.$toast("请先点击选择对调老师次");
          return;
        }
        this.timer = Math.random() * 100 * Math.random();
        this.ddParmMsg.teacherId = this.bgls.dm;
        this.ddParmMsg.kbid = this.itemList.coursePlanId;
        this.showDdkb = true;
        return;
      }
      if (value + "" == "ddzc") {
        if (this.ddkb.kbId == null || this.ddkb.kbId == "") {
          this.$toast("请先选择对调课表");
          return;
        }
      }
      if (value + "" == "tklx") {
        this.ddkb = {};
        this.columns.ddkb = [];
      }
      // 显示地点
      if (
        value + "" == "dd" &&
        (JSON.stringify(this.xq) == "{}" ||
          JSON.stringify(this.qzjc) == "{}") &&
        this.tklxdm != "9"
      ) {
        this.$toast("请先点击选择星期几和起止节次");
        return;
      }
      // 显示起止节次
      if (value == "qzjc" && JSON.stringify(this.xq) == "{}") {
        this.$toast("请先点击选择星期几");
        return;
      }
      // 显示调课类型
      if (value + "" != "tkfs" && this.tkfs.mc == "") {
        this.$toast("请先点击选择调课方式");
        return;
      }
      if (value + "" == "dd") {
        if (this.tklxdm == "9") {
          this.getDd();
        }
        this.showTkdd();
        return;
      }
      if (value + "" == "tklx" && this.schoolCode == "12662") {
        this.initShrList();
      }
      this.valueList.value = "" + value;
      if (this.schoolCode == "10759" && this.isTk == "not" && value == "tklx") {
        this.valueList.item = ["整体调课", "部分调课", "变更老师"];
      } else {
        this.valueList.item = this.columns["" + value];
      }
      this.valueList.label = label;
      if (this.valueList.item.length == 0) {
        this.$toast("暂无合适的" + label);
      } else {
        this.show = true;
      }
    },
    initTkWeekend() {
      if (!this.itemList.nowWeek || this.itemList.nowWeek == "") {
        this.selectIndex = 0;
        return;
      }
      let range = this.itemList.weekDetail.split(",");
      let index = 0;
      for (let j = 0; j < range.length; j++) {
        if (range[j] != "") {
          if (range[j] == this.itemList.nowWeek) {
            this.selectIndex = index;
          } else {
            index++;
          }
        }
      }
    },
    openShrWd() {
      if (this.schoolCode == "12662" && this.xsShLcKz == "1") {
        if (this.tklx == "") {
          this.$toast("请先选择调课类型");
          return;
        }
        this.initShrList();
        this.show1 = true;
      } else {
        this.show1 = true;
      }
    },
    getTkxsNb(tkWeek) {
      let weekArr = tkWeek.split(",");
      let weekNb = 0;
      for (let i = 0; i < weekArr.length; i++) {
        if (weekArr[i] != "") {
          weekNb++;
        }
      }
      let tkXsNb = ((this.itemList.weekNote.length - 1) / 2) * weekNb;
      return tkXsNb;
    },
    initShrList() {
      let tkWeek = "1";
      if (this.tklx == "整体调课") {
        tkWeek = this.itemList.weekDetail;
      }
      let tkXsNb = this.getTkxsNb(tkWeek);
      if (tkXsNb >= this.xsShXsSum) {
        this.shrList = this.shrList_other;
        if ((this.nowCoderStuts = "0")) {
          this.shr = {};
        }
        this.nowCoderStuts = "1";
      } else {
        if ((this.nowCoderStuts = "1")) {
          this.shr = {};
        }
        this.shrList = this.shrListDefult;
        this.nowCoderStuts = "0";
      }
    },
    onConfirm_tklb() {},
    onConfirm(value, index, value1) {
      if (value1 + "" === "tkyy") {
        this.show = false;
        this.tkyy = value;
        return;
      }
      // 控制调课类型的申请条件
      if (value1 + "" === "tklx") {
        this.showType = true;
        if (value === "整体调课") {
          this.tklxdm = "0";

          this.tkType = [false, false, false, false, false];
          this.tkType[0] = true;
          // 获取星期列表
          this.getXq();
          // 获取审核人列表
          this.getShr();
        } else if (value === "部分调课") {
          this.tklxdm = "1";

          this.tkType = [false, false, false, false, false];
          this.tkType[1] = true;
          // 获取教学变更周次列表
          this.getJxbgzc();
          // 获取星期列表
          this.getXq();
          // 获取审核人列表
          this.getShr();
        } else if (value === "变更老师") {
          this.tklxdm = "5";

          this.tkType = [false, false, false, false, false];
          this.tkType[2] = true;
          // 获取教学变更周次列表
          this.getJxbgzc();
          // 获取星期列表
          this.getXq();
          // 获取审核人列表
          this.getShr();
        } else if (value === "课程对调") {
          this.tklxdm = "6";

          this.tkType = [false, false, false, false, false];
          this.tkType[4] = true;
          // 获取教学变更周次列表
          this.getJxbgzc();
          // 获取审核人列表
          this.getShr();
        } else if (value === "停课") {
          this.tklxdm = "2";

          this.tkType = [false, false, false, false, false];
          this.tkType[3] = true;
          // 获取教学变更周次列表
          this.getJxbgzc();
          // 获取审核人列表
          this.getShr();
        } else if (value == "调整教室") {
          this.tklxdm = "9";

          this.tkType = [false, false, false, false, false];
          this.tkType[3] = true;
          // 获取星期列表
          this.getXq();
          // 获取审核人列表
          this.getShr();
        }
      }
      if (value1 == "xq") {
        this[value1].mc = value[0].text;
        this[value1].dm = value[0].value;
        this.qzjc = {};
        this.dd = {};
        // 获取起止节次列表
        this.getQzjc();
      } else if (value1 == "qzjc") {
        this[value1].mc = value;
        this[value1].dm = this.qzjcList.dm[index];
        this.dd = {};
        // 获取地点列表
        this.getDd();
      } else if (value1 == "jxbgzc") {
        if (this.schoolCode == "12763") {
          if (this.tkType[3] || this.tkType[4]) {
            this.jxbgzc = "第" + value[0] + "周";
            this.bgzc = value[0];
          } else {
            this.jxbgzc = "第" + value[0] + "周变更为第" + value[1] + "周";
            if (value[0] != this.itemList.nowWeek) {
              this.getXq(true);
            } else {
              this.getXq();
            }
            if (
              value[0] != this.itemList.nowWeek &&
              this.xq.dm < Number(this.itemList.nowXq)
            ) {
              this.xq = {};
            }
            this.bgzc = value;
          }
        } else {
          if (this.tkType[3] || this.tkType[4]) {
            this.jxbgzc = "第" + value + "周";
          } else {
            this.jxbgzc = "第" + value[0] + "周变更为第" + value[1] + "周";
          }
          this.bgzc = value;
        }
      } else if (value1 == "bgls") {
        if (this.tkType[4]) {
          this.ddkb = {
            mc: "",
            dm: ""
          };
        }
      } else if (value1 == "tkfs") {
        this[value1].mc = value;
        this[value1].dm = this.tkfsList.dm[index];
      } else if (value1 == "tklb") {
        this[value1].mc = value;
        this[value1].dm = this.tklbList.dm[index];
      } else if (value1 == "dd") {
        this.dd = {
          mc: value,
          dm: this.ddList.dm[index]
        };
      } else if (value1 == "ddzc") {
        this.ddkb.ddzc = value.value;
        this.ddkb.ddzcName = "第" + value.value + "周";
      } else if (value1 == "checkXsCt") {
        this.checkStudentCt = this.checkCtCoum.mc[index];
        this.checkStudentCtDm = this.checkCtCoum.dm[index];
      } else {
        this[value1] = value;
      }
      this.show = false;
    },
    // 获取对调课程
    async getAlterCourse() {
      this.alterCourseList = [];
      const params = {
        week: this.bgzc[0] || "",
        week1: this.bgzc[1] || "",
        jgh: this.bgls.dm
      };
      const res = await Api.exchangeQuery(params);
      if (res.code == "1") {
        if (!this.bgzc) {
          this.week = "第" + res.data[0].topInfo[0].week + "周";
        }
        if (res.data[0].courses.length > 0) {
          this.columns.ddkb = res.data[0].courses.map(item => {
            return {
              text: item.courseName,
              value: item.coursePlanId
            };
          });
        } else {
          this.$toast(res.Msg);
        }
      }
    },
    // 获取调课方式列表
    async getTkfs() {
      let mc = [];
      let dm = [];
      let param = {
        xnxq: this.itemList.semesterId
      };
      const res = await Api.teachChangeModeList(param);
      if (this.schoolCode == "10759") {
        this.isTk = res.isTk;
      }
      if (this.schoolCode == "10054") {
        this.ttksm = res.ttksm;
        this.tkfilename = res.tkfilename
      }
      res.data.forEach(item => {
        mc.push(item.studentNumber);
        dm.push(item.dm);
      });
      this.tkfsList.dm = dm;
      this.tkfsList.mc = mc;
      this.columns.tkfs = this.tkfsList.mc;
      if (this.schoolCode == "12981") {
        this.tkfs = { mc: "个人调课", dm: "0" };
      }
    },
    // 获取调课类别列表
    async getTklb() {
      let mc = [];
      let dm = [];
      let param = {
        tableName: "ZZDTKLB",
        zzdtype: "currencyDic"
      };
      const res = await Api.findDictionry(param);
      res.data.currencyDic.forEach(item => {
        mc.push(item.dmmc);
        dm.push(item.dm);
      });
      this.tklbList.dm = dm;
      this.tklbList.mc = mc;
      this.columns.tklb = this.tklbList.mc;
    },
    // 获取调课类型列表
    getTklx() {
      this.tklxList = ["整体调课", "部分调课", "变更老师", "停课"];

      if (
        this.schoolCode == "14073" ||
        this.schoolCode == "66666" ||
        this.schoolCode == "51717" ||
        this.schoolCode == "12981"
      ) {
        this.tklxList = [
          "整体调课",
          "部分调课",
          "变更老师",
          "停课",
          "课程对调"
        ];
      } else if (this.itemList.sfsyk == "1" && this.schoolCode == "11534") {
        this.tklxList = ["部分调课", "停课"];
      } else if (this.schoolCode == "13208") {
        this.tklxList = [
          "整体调课",
          "部分调课",
          "变更老师",
          "停课",
          "调整教室"
        ];
      } else if (this.schoolCode == "14197") {
        this.tklxList = ["部分调课", "变更老师", "停课"];
      }
      this.columns.tklx = this.tklxList;
      if (this.schoolCode == "12981") {
        this.tklx = "部分调课";
        this.onConfirm("部分调课", "1", "tklx");
      }
    },
    async getTklx_11114(){
      let param = {
        xnxq: this.itemList.semesterId
      };
      const res = await Api.changeTklxList(param);
      this.tklxList = res.data
    
    },
    // 获取教学变更周次列表
    async getJxbgzc() {
      this.jxbgzcList = [
        {
          values: [],
          className: "column1",
          defaultIndex: 0
        },
        {
          values: [],
          className: "column2",
          defaultIndex: 1
        }
      ];
      if (this.schoolCode == "12763") {
        // 停课周次
        if (this.tkType[3] || this.tkType[4]) {
          let range = this.itemList.weekDetail.split(",");
          if (!(this.itemList.nowWeek && this.itemList.nowWeek != "")) {
            return;
          }
          this.jxbgzcList[0].values = range.filter(item => {
            return Number(item) >= Number(this.itemList.nowWeek);
          });
          this.jxbgzcList[0].defaultIndex = 0;
          if (this.jxbgzcList[0].values.length) {
            this.columns.jxbgzc = [this.jxbgzcList[0]];
          }
          return;
        }

        //周次次列表（下拉框）
        const res = await Api.getTeachingWeek();
        let range = this.itemList.weekDetail.split(",");
        if (!(this.itemList.nowWeek && this.itemList.nowWeek != "")) {
          return;
        }
        this.jxbgzcList[0].values = range.filter(item => {
          return Number(item) >= Number(this.itemList.nowWeek);
        });
        if (this.jxbgzcList[0].values.length) {
          this.jxbgzcList[1].values = res.data
            .filter(item => {
              return Number(item.week) >= Number(this.itemList.nowWeek);
            })
            .map(item => item.week);
          this.jxbgzcList[1].defaultIndex = 0;
          this.columns.jxbgzc = this.jxbgzcList;
        }
      } else {
        // 停课周次
        if (this.tkType[3] || this.tkType[4]) {
          let range = this.itemList.weekDetail.split(",");
          let arr = [];
          let index = 0;
          for (let j = 0; j < range.length; j++) {
            if (range[j] != "") {
              arr.push(range[j]);
              if (
                this.itemList.nowWeek &&
                this.itemList.nowWeek != "" &&
                this.itemList.nowWeek == range[j]
              ) {
                this.jxbgzcList[0].defaultIndex = index;
              }
              index++;
            }
          }
          this.jxbgzcList[0].values = arr;
          this.columns.jxbgzc = this.jxbgzcList[0].values;
          return;
        }

        //周次次列表（下拉框）
        const res = await Api.getTeachingWeek();
        let range = this.itemList.weekDetail.split(",");
        let arr1 = [];
        let index = 0;
        for (let j = 0; j < range.length; j++) {
          if (range[j] != "") {
            arr1.push(range[j]);
            if (
              this.itemList.nowWeek &&
              this.itemList.nowWeek != "" &&
              this.itemList.nowWeek == range[j]
            ) {
              this.jxbgzcList[0].defaultIndex = index;
            }
            index++;
          }
        }
        this.jxbgzcList[0].values = arr1;
        res.data.forEach(item => {
          this.jxbgzcList[1].values.push(item.week);
        });
        if (this.itemList.nowWeek && this.itemList.nowWeek != "") {
          this.jxbgzcList[1].defaultIndex = this.itemList.nowWeek - 1;
        }
        this.columns.jxbgzc = this.jxbgzcList;
      }
    },
    // 获取星期列表
    getXq(flag) {
      let arr = [
        { text: "星期一", value: "1" },
        { text: "星期二", value: "2" },
        { text: "星期三", value: "3" },
        { text: "星期四", value: "4" },
        { text: "星期五", value: "5" },
        { text: "星期六", value: "6" },
        { text: "星期天", value: "7" }
      ];
      if (this.schoolCode == "12763" && !flag) {
        if (!(this.itemList.nowXq && this.itemList.nowXq != "")) {
          return;
        }

        this.xqList = [
          {
            values: arr.filter((item, index) => {
              return index >= Number(this.itemList.nowXq);
            })
          }
        ];
      } else {
        this.xqList = [
          {
            values: arr
          }
        ];
      }
      this.columns.xq = this.xqList;
    },
    // 获取起止节次列表
    async getQzjc() {
      let params = {};
      if (this.tkType[0]) {
        params = {
          coursePlanId: this.itemList.coursePlanId,
          weekNote: this.itemList.weekNote,
          noticeId: this.itemList.noticeId,
          week: this.itemList.week,
          timeFlag: this.itemList.timeFlag,
          oldWeek: this.itemList.week,
          changeType: this.$route.query.isEx ? "6" : "0",
          tkxq: this.xq.dm
        };
      } else if (this.tkType[1]) {
        params = {
          coursePlanId: this.itemList.coursePlanId,
          weekNote: this.itemList.weekNote,
          noticeId: this.itemList.noticeId,
          week: this.bgzc[1],
          timeFlag: this.itemList.timeFlag,
          oldWeek: this.bgzc[0],
          changeType: "1",
          tkxq: this.xq.dm
        };
      } else if (this.tkType[2]) {
        params = {
          coursePlanId: this.itemList.coursePlanId,
          weekNote: "",
          noticeId: this.itemList.noticeId,
          week: this.bgzc[1],
          timeFlag: this.itemList.timeFlag,
          oldWeek: this.bgzc[0],
          changeType: "5",
          tkxq: this.xq.dm
        };
      }
      if (this.itemList.sfsyk == "1" && this.schoolCode == "11534") {
        let dm = [];
        let mc = [];
        const res = await Api.getkysj_sy(params);
        res.data.forEach(item => {
          if (this.xq.dm == item.weekDay) {
            mc.push(item.bigNode);
            dm.push(item.nodes);
          }
        });

        this.qzjcList.mc = mc;
        this.qzjcList.dm = dm;
        this.columns.qzjc = this.qzjcList.mc;

        return;
      }
      let dm = [];
      let mc = [];
      params.jx0405id = this.itemList.arrangeId;
      const res = await Api.getTeachGetkysj(params);
      if (res.data != null) {
        res.data.forEach(item => {
          if (this.xq.dm == item.weekDay) {
            mc.push(item.bigNode);
            dm.push(item.nodes);
          }
        });
      }

      this.qzjcList.mc = mc;
      this.qzjcList.dm = dm;
      this.columns.qzjc = this.qzjcList.mc;
    },
    // 获取地点列表
    async getDd() {
      this.columns.dd = this.ddList;
      let dtWeek = this.bgzc[1] + "-" + this.bgzc[1];
      if (this.tklx == "整体调课") {
        dtWeek = this.itemList.week;
      }
      let params = {
        noticeId: this.itemList.noticeId,
        semesterId: this.itemList.semesterId,
        weekNote: this.qzjc.dm,
        week: dtWeek,
        timeFlag: this.itemList.timeFlag,
        validSeat: "",
        domainId: "",
        classroomName: "",
        changeType: this.tklxdm,
        coursePlainId: this.itemList.coursePlanId,
        campusId: this.tkddmc.selectXqid,
        teachingBuildingId: this.tkddmc.selectJxlid,
        classroomType: this.tkddmc.selectJslxid
      };
      if (this.tklxdm == "9") {
        params.week = this.itemList.week;
      }
      if (this.itemList.sfsyk == "1" && this.schoolCode == "11534") {
        params.week = this.bgzc[0] + "-" + this.bgzc[1];
        let dm = [];
        let mc = [];
        const res = await Api.getkyjs_sy(params);
        if (!res.data) {
          this.ddList.dm = [];
          this.ddList.mc = [];
          this.columns.dd = this.ddList.mc;
        } else {
          res.data.forEach(item => {
            dm.push(item.classroomIds);
            mc.push(item.classroomName);
          });
          this.ddList.dm = dm;
          this.ddList.mc = mc;
          this.columns.dd = this.ddList.mc;
        }
        return;
      }

      let dm = [];
      let mc = [];
      const res = await Api.getTeachGetkyjs(params);
      if (!res.data) {
        this.ddList.dm = [];
        this.ddList.mc = [];
        this.columns.dd = this.ddList.mc;
      } else {
        res.data.forEach(item => {
          dm.push(item.classroomIds);
          mc.push(item.classroomName);
        });
        this.ddList.dm = dm;
        this.ddList.mc = mc;
        this.columns.dd = this.ddList.mc;
      }
    },
    // 获取审核人列表
    async getShr() {
      let concatList2 = [];
      let concatList3 = [];
      this.shrList = [
        {
          id: "",
          name: "全部",
          isBtn: 0
        }
      ];
      this.shrList_other = this.shrList;
      let params = {
        ywcode: "009",
        ywid: this.itemList.noticeId,
        jx0404id: this.itemList.noticeId
      };
      if (this.itemList.sfsyk == "1") {
        params.ywcode = "095";
      } else if (this.schoolCode == "11534") {
        if (this.tklxdm == "0") {
          params.ywcode = this.itemList.ywcode_zt;
        } else {
          params.ywcode = this.itemList.ywcode_dz;
        }
      }
      const res = await Api.selectReviewerApi(params);
      res.data.forEach((item, index) => {
        concatList2[index] = {
          name: item.userrealname,
          id: item.userid,
          isBtn: 0
        };
      });
      this.shrList = this.shrList.concat(concatList2);
      this.shrListDefult = this.shrList;
      if (res.otherData) {
        res.otherData.data.forEach((item, index) => {
          concatList3[index] = {
            name: item.userrealname,
            id: item.userid,
            isBtn: 0
          };
        });
        this.shrList_other = this.shrList_other.concat(concatList3);
        this.xsShLcKz = res.isHaveOtherCoder;
        this.xsShXsSum = res.otherProm * 1;
        this.otherCoder = res.otherCode;
      }
    },
    // 审核人弹框中的按钮选择
    personTap(e, res) {
      let strList = [];
      let idList = [];
      if (this.shrList[res].isBtn == 0) {
        this.shrList[res].isBtn = 1;
        e.target.className = "cur";
      } else if (this.shrList[res].isBtn == 1) {
        this.shrList[res].isBtn = 0;
        e.target.className = "per-btn";
      }
      for (let i in this.shrList) {
        if (this.shrList[res].name == "全部") {
          this.shrList[i].isBtn = 0;
          this.shrList[res].isBtn = 1;
          this.$refs.person[res].className = "cur";
          this.$refs.person[i].className = "per-btn";
        } else {
          this.shrList[0].isBtn = 0;
          this.$refs.person[0].className = "per-btn";
        }
        if (this.shrList[i].isBtn == 1) {
          strList = strList.concat(this.shrList[i].name);
          idList = idList.concat(this.shrList[i].id);
        }
      }
      this.reset = strList.toString();
      this.resetId = idList.toString();
    },
    // 审核人选择完后点击确认
    resetCancel() {
      this.show1 = false;
      this.shr.mc = this.reset;
      this.shr.dm = this.resetId;
    },
    // 关闭变更老师的pop
    closeBgls(res, id, name) {
      this.show3 = res;
      if (!name) {
        this.bgls.mc = "";
        this.bgls.dm = "";
        this.ddkb = {};
        this.columns.ddzc = [];
      } else {
        this.bgls.mc = name;
      }
      this.bgls.dm = id;
      //if (this.tkType[4]) {
      //只有对调才需要调用此方法
      //this.getAlterCourse();
      //}
    },
    // 对调课表的pop
    closeDtKb(res, kbId, kbTime, weekDeal) {
      this.showDdkb = res;
      if (kbTime != null && kbTime != undefined && kbTime != "") {
        this.ddkb.ddzc = "";
        this.ddkb.ddzcName = "";
        this.ddkb.kbId = kbId;
        this.ddkb.kbTime = kbTime;
        let ddzcmx = weekDeal.split(",");
        this.columns.ddzc = [];
        for (let i = 0; i < ddzcmx.length; i++) {
          if (ddzcmx[i] != "") {
            let tmpCout = { text: ddzcmx[i], value: ddzcmx[i] };
            this.columns.ddzc.push(tmpCout);
          }
        }
      }
    },
    // 获取调课得课程信息
    getItem() {
      this.itemList = this.$route.query.i_item;
      if (!!this.itemList.coursePlanId) {
      } else {
        this.active = 1;
        this.isAble = true;
      }
    },
    // 获取申请记录
    async getApply() {
      const params = {
        auditState: this.optionDM
      };
      if(this.schoolCode == '10689'){
        params.semesterId = this.xnxqval
      }
      const res = await Api.teachGetJstkxx(params);
      this.applyList = res.data;
      this.allList = res.data;

      for (let item of this.applyList) {
        if (item.auditStateName == "审核中") {
          item.class = "shzClass";
        } else if (item.auditStateName == "不通过") {
          item.class = "btgClass";
        } else if (item.auditStateName == "通过") {
          item.class = "ytgClass";
          item.auditStateName = "已通过";
        } else if (item.auditStateName == "待送审") {
          item.class = "dssClass";
        }
      }
    },
    // 申请记录的条件选择
    change(value) {
      this.getApply();
    },
    async showTkdd() {
      let params = {
        zzdtype: "Campus,TeachBud,ClassRoomType"
      };
      const res = await Api.findDictionry(params);
      if (res.data) {
        if (res.data.Campus) {
          this.tkddmc.xqList = res.data.Campus;
        }
        if (res.data.TeachBud) {
          this.tkddmc.jxlList = res.data.TeachBud;
        }
        if (res.data.ClassRoomType) {
          this.tkddmc.jslxList = res.data.ClassRoomType;
        }
      }
      //this.tkddmc.xqList = res.data;
      //const resjslx = await Api.findZzdJslx();
      //this.tkddmc.jslxList = resjslx.data;

      this.tkdd_show = true;
      this.tkddmc.active = 3;
    },
    async changeXq(xq) {
      let param = {
        xqid: xq.xqid,
        zzdtype: "TeachBud"
      };
      if (xq.xqmc == "所有校区") {
        this.tkddmc.xqmc = "校区";
      } else {
        this.tkddmc.xqmc = xq.xqmc;
      }

      const res = await Api.findDictionry(param);
      if (res.data) {
        if (res.data.TeachBud) {
          this.tkddmc.jxlList = res.data.TeachBud;
        }
      }
      this.tkddmc.active = 1;
    },
    async changeJxl(jxl) {
      if (jxl.jzwmc == "所有教学楼") {
        this.tkddmc.jxlmc = "教学楼";
      } else {
        this.tkddmc.jxlmc = jxl.jzwmc;
      }
      this.tkddmc.active = 2;
    },
    async changeJslx(jslx) {
      if (jslx.jslxmc == "所有教室类型") {
        this.tkddmc.jslxmc = "教室类型";
      } else {
        this.tkddmc.jslxmc = jslx.jslxmc;
      }
      this.tkddmc.active = 3;
      this.getDd();
    },
    async changeJsmc(dm, mc) {
      this.dd = {
        mc: mc,
        dm: dm
      };
      this.tkdd_show = false;
    },
    async freshClassRoom() {
      if (this.tkddmc.active == 3) {
        this.getDd();
      }
    },
    async doCancelSh(item) {
      var param = {
        tkid: item.changeId
      };
      const res = await Api.doCxTkJl(param);
      if (res.code == "1") {
        setTimeout(() => {
          this.$toast.success("撤销成功！");
          this.$router.go(0);
        }, 500);
      }
    },
    async dowloadTksm(){
      const res = await Api.fileDownloadTkFj();
      if (res.code && res.code == "0") {
        this.$toast("下载失败！");
      } else {
        const href = URL.createObjectURL(res);
        const a = document.createElement("a");
        a.download = this.tkfilename;
        a.href = href;
        a.click();
      }
    },
    async getXnxq() {
      const res = await Api.findDictionry({ zzdtype: "xnxq" });
      if (res.code == "1") {
        this.xnxqOption = res.data.xnxq.map((item, index) => {
          if ( item.isdqxq == '1') {
            this.xnxqval = item.xnxq01id;
          }
          return {
            text: item.xqmc,
            value: item.xnxq01id
          };
        })
      }
      this.xnxqOption.unshift({text:'全部',value:''})
    },
  },
  created() {
    this.schoolCode = sessionStorage.getItem("schoolCode");
    // 获取调课得课程信息
    this.getItem();
    // 获取调课类型列表
    if(this.schoolCode == '11114'){
      this.getTklx_11114();
    }else{
      this.getTklx();
    }
    // 获取调课方式列表
    this.getTkfs();
    //获取调课类别
    if (this.schoolCode == "4152014577") {
      this.getTklb();
    }
    this.initTkWeekend();
    this.columns.checkXsCt = this.checkCtCoum.mc;
    if(this.schoolCode == '10689'){
      this.getXnxq();
    }
    if(this.schoolCode == '13720'){
      this.fileUploadType = '.pdf,.png,.jgp'
    }
  },
  components: {
    alterTeacher,
    alterTeacherKbMsg
  }
};
</script>
<style lang="less">
.exchangeI {
  .van-tabs__content--animated {
    height: 75vh;
    overflow: auto;
  }
  .van-tabs--line .van-tabs__wrap {
    border-bottom: 1px solid #f4f4f4;
    .van-tab--active {
      .van-tab__text--ellipsis {
        color: #212f6e !important;
      }
    }
    .van-tab__text--ellipsis {
      width: 56px;
      height: 20px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #8f95b5;
      letter-spacing: 0;
    }
    .van-tabs__line {
      background-color: #7469f8 !important;
      width: 25px;
      height: 3px;
      border-radius: 1.5px;
    }
  }
  .applyInfo {
    width: 100%;
    height: 100%;
    padding: 7% 5% 0 5%;
    p {
      height: 25px;
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: #212f6e;
      letter-spacing: 0;
      margin-bottom: 2%;
      font-weight: bolder;
      margin-bottom: 8px;
    }
    ul li {
      font-family: PingFangSC-Light;
      font-size: 14px;
      color: #757da3;
      letter-spacing: 0;
      margin-bottom: 2%;

      span {
        font-weight: bolder;
        word-wrap: break-word;
        display: inline-block;
        width: 80%;
      }
    }
    ul li:last-child {
      display: flex;
      align-items: stretch;
    }
  }
  .apply {
    padding: 0 3% 0;
    .van-cell {
      border-bottom: 1px solid #f4f4f4;
    }
    .van-cell::after {
      display: none;
    }
    .van-field__label {
      width: 7.2em;
      span {
        width: 96px !important;
        display: inline-block;
      }
    }
    .van-cell.van-field .van-cell__title.van-field__label > span {
      font-family: PingFangSC-Light;
      font-size: 16px;
      color: #212f6e;
      letter-spacing: 0;
    }
    .van-field__control::-webkit-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      font-weight: normal;
      text-align: right;
    }
    .van-field__control::-moz-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      font-weight: normal;
      letter-spacing: 0;
      text-align: right;
    }
    .van-field__control::-ms-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      font-weight: normal;
      text-align: right;
    }
    .van-field__control {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #212f6e;
      letter-spacing: 0;
      text-align: right;
      font-weight: bolder;
    }
    .van-icon-arrow {
      color: #dfe0e6;
      font-weight: bolder;
      font-size: 14px;
    }
    .van-cell__title,
    .van-cell.van-field .van-cell__title.van-field__label > span {
      width: 64px;
      height: 22px;
      font-family: PingFangSC-Light;
      font-size: 16px;
      color: #212f6e;
      letter-spacing: 0;
    }
    .van-icon-eye-o,
    .van-icon-eye,
    .van-icon-smile-o,
    .van-icon-smile,
    .van-icon-location,
    .van-icon-location-o,
    .van-icon-like,
    .van-icon-like-o,
    .van-icon-fire-o,
    .van-icon-fire,
    .van-icon-setting {
      font-family: "iconfont" !important;
      font-size: 22px;
      font-style: normal;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      color: #212f6e;
    }
    .van-icon-eye-o::before {
      content: "\e6ba";
    }
    .van-icon-eye::before {
      content: "\e6b8";
    }
    .van-icon-smile-o::before {
      content: "\e6bd";
    }
    .van-icon-smile::before {
      content: "\e6c1";
    }
    .van-icon-location::before {
      content: "\e6b4";
    }
    .van-icon-location-o::before {
      content: "\e6bb";
    }
    .van-icon-like::before {
      content: "\e6be";
    }
    .van-icon-like-o::before {
      content: "\e6db";
    }
    .van-icon-fire-o::before {
      content: "\e6e7";
    }
    .van-icon-fire::before {
      content: "\e6de";
    }
    .van-icon-setting::before {
      content: "\e6df";
    }

    .van-field__control::-webkit-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      text-align: right;
    }
    .van-field__control::-moz-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      text-align: right;
    }
    .van-field__control::-ms-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      text-align: right;
    }
  }
  .applyList {
    .list {
      padding: 5% 5% 0;
      .list-item {
        background: #f8f8f8;
        border-radius: 5px;
        margin-bottom: 5%;
        padding: 3% 0 3% 6%;
        position: relative;
        p {
          height: 22px;
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #212f6e;
          letter-spacing: 0;
          margin-bottom: 2%;
        }
        ul li {
          height: 17px;
          font-family: PingFangSC-Light;
          font-size: 12px;
          color: #757da3;
          letter-spacing: 0;
          margin-bottom: 1%;
        }
        span {
          height: 20px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          letter-spacing: 0;
          position: absolute;
          top: calc(50% - 10px);
          right: 5%;
          font-weight: bolder;
        }
        .shzClass {
          color: #7469f8;
        }
        .btgClass {
          color: #f86969;
        }
        .ytgClass {
          color: #12ddd6;
        }
        .dssClass {
          color: #757da3;
        }
      }
    }
    .van-ellipsis {
      height: 20px;
      font-family: PingFangSC-Medium;
      font-size: 15px;
      color: #212f6e;
      letter-spacing: 0;
      font-weight: bolder;
    }
    .van-cell {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #212f6e;
      letter-spacing: 0;
    }
    .van-dropdown-menu {
      border-bottom: 1px solid #f4f4f4;

      .van-dropdown-menu__bar {
        box-shadow: none;
      }
      .van-dropdown-item {
        position: static;
        height: 1000px;

        .van-overlay {
          top: 49px;
          left: 100%;
        }
        .van-popup--top {
          top: 49px;
          left: 100%;
        }
      }
    }
  }

  .tksm_btnsm{
    align-items: center;
    line-height: 44px;
    button {
      width: 36%;
      height: 44px;
      background: #7469F8;
      border-radius: 3px;
      color: #fff;
    }
  }
  .bottom-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    padding-bottom: 10px;
    padding: 0 5%;
    background: #fff;
    box-sizing: border-box;

    button {
      width: 100%;
      height: 44px;
      background: #7469f8;
      border-radius: 3px;
      color: #fff;
    }
  }
}
/* 审核人 */
.close-icon {
  background: url(../../../../../static/img/close.png) no-repeat center;
}
.confirm-icon {
  background: url(../../../../../static/img/confirm.png) no-repeat center;
}
.pop-title i {
  width: 22px;
  height: 22px;
  background-size: 22px 22px;
  padding: 10px;
}
.pop-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.person {
  padding: 15px;
}
.person button {
  border-radius: 3px;
  padding: 5px 15px;
  margin-right: 12px;
  margin-bottom: 10px;
}
.apply-pop .person .per-btn {
  background-color: #ecedfd;
  color: #7469f8;
}
.person .cur {
  background-color: #7469f8;
  color: #ecedfd;
}
.popup_title {
  padding-left: 10px;
  padding-top: 10px;
  margin-bottom: 10px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  span {
    font-weight: Regular;
    font-size: 12px;
    color: #999999;
    letter-spacing: 0;
  }
}

.csdiv {
  text-align: right;
  padding-right: 5px;
  button {
    background: #7469f8;
    color: #fff;
    width: 60px;
    border-radius: 3px;
    font-size: 14px;
    height: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/exchangeK/item.vue